import React, { useState } from 'react'
import { Document, Page, Text, StyleSheet,View,Font  } from '@react-pdf/renderer';
import { HoraActual, calcularEdad, fechaActual } from '../../../hooks/UseDate';
import { postInformacionEmpresa } from '../../../services/PaginaRuta';


  // Registro de fuente personalizada
Font.register({
  family: 'Open Sans',
  fonts: [
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 }
  ]
})
const styles = StyleSheet.create({    
    title: {
      fontSize: 9,
      textAlign: 'center',     
    },
    date: {
      fontSize: 9,
      marginTop: 3, // Agregar margen en la parte superior de la fila
      marginBottom: 3, // Agregar margen en la parte inferior de la fila
    },    
    line: {
        marginTop: 2,
        borderTop: '1pt solid #000',
        marginTop: 4,
      },
    bold: {
      fontFamily: 'Open Sans',
      fontWeight: 600
    },
    container: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    column: {
      width: '50%',      
      fontSize: 9
    },
    header: {
      fontSize: 12,
      fontWeight: 'bold',
      marginBottom: 5,
    },
    text: {
      fontSize: 12,
    },
    table: { 
      display: "table", 
      width: "auto", 
      borderStyle: "none",      
    }, 
    tableRow: {       
      flexDirection: "row" 
    }, 
    
    tableCell: { 
      width: "25%",
      padding: '3px',      
      fontSize: 8 
    },
    
    tableCellLarge:{
      width: "50%",
      padding: '3px',      
      fontSize: 8 
    },
    textBox: {
      padding: 10,
      backgroundColor: '#e0e0e0',  // color gris
      fontSize: 9,
      marginTop: 3, // Agregar margen en la parte superior de la fila
      marginBottom: 3, // Agregar margen en la parte inferior de la fila
    },
  
  });
const PDFProgramacionCirugias = ({dataProgramacionCirugia,fechaFinal,fechaInicial,informacionEmpresa}) => {
//   const [informacionEmpresa, setinformacionEmpresa]=useState([])
//   const datosEmpresa={
//     "EMPCOD":"1",
//     "MCDpto":"001"
// }
    // postInformacionEmpresa(datosEmpresa).then((res)=>{
    //   setinformacionEmpresa(res.data[0])
    // })
    
    return (
      <Document>
        <Page size='A4' style={{padding: '20px' }}>
        <View >
          <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 600}}>{informacionEmpresa.EmpRazSoc}</Text>            
            <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 600}}>{informacionEmpresa.EmpNit}</Text>
            <Text style={styles.title}><Text style={styles.bold}>PROGRAMACION DIARIA DE CIRUGIAS</Text></Text>
            <Text style={styles.title}>Fecha prog desde: {fechaInicial} hasta: {fechaFinal}</Text>
            <Text style={styles.date}><Text style={styles.bold}>Hora:</Text> {HoraActual()}</Text>
            <Text style={styles.date}><Text style={styles.bold}>Fecha:</Text> {fechaActual()}</Text>   
            {/* <Text style={styles.date}><Text style={styles.bold}>Sede:</Text> 001</Text>          */}
          </View>
          
          {
            dataProgramacionCirugia.map((item,index)=>(
              <>
                <View style={styles.line} />
                <Text style={styles.textBox}><Text style={styles.bold}>Paciente:</Text> {item.MPNOMC? item.MPNOMC.trim() :null}      {item.MPCedu? item.MPCedu.trim():null}      <Text style={styles.bold}>Edad:</Text> {item.MPFchN?calcularEdad(item.MPFchN.split(' ')[0]):null} AÑOS       </Text>
                <View style={styles.container}>
          <View style={styles.column}>
            <Text><Text style={styles.bold}>Sala:</Text> {item.ProCons?item.ProCons:null} {item.ProNcons? item.ProNcons:null} </Text>
            <Text><Text style={styles.bold}>Anestesia:</Text> </Text>
            <Text><Text style={styles.bold}>Cirugia:</Text>  {item.ProCirCod? item.ProCirCod:null } </Text>         
            <Text><Text style={styles.bold}>Fecha Inicial:</Text>  {item.ProFec? item.ProFec:null} </Text>    
            <Text><Text style={styles.bold}>Tipo Atención:</Text> {item.ClaPro === '1'?'AMBULATORIO': (item.ClaPro === '2'?'HOSPITALIZACION':(item.ClaPro === '3'?'URGENCIAS':null))}</Text>
            <Text><Text style={styles.bold}>Estado:</Text>  {item.ProEsta ==='6'? 'Pendiente': 
                  (item.ProEsta ==='3'? 'Cancelado': 
                  (item.ProEsta === '4'? 'Realizado' : 
                  (item.ProEsta === '5'? 'Facturado' : 
                  (item.ultimoEstado === 'reservado'? 'Reservado' : 
                  (item.ultimoEstado === 'confirmado'? 'confirmado' : 
                  (item.ultimoEstado === 'ingreso a sala'? 'ingreso a sala' : 
                  (item.ultimoEstado ==='cirugia'? 'cirugia':
                  (item.ultimoEstado ==='recuperacion'? 'recuperacion':
                  (item.ultimoEstado === 'salida'? 'salida':
                  (item.ProEsta === '1'? 'Reservado':
                  (item.ProEsta === '7'? 'Reservado':
                  (item.ProEsta === '2'? 'confirmado':
                  (item.ProEsta === '8'? 'Pendiente':null)))))))))))))}    </Text>
            
          </View>
          <View style={styles.column}>
            <Text><Text style={styles.bold}>Tipo:</Text> {item.ProSit === '1'? 'PROGRAMADA':(item.ProSit === '2'? 'URGENCIAS':null)} </Text> 
            <Text><Text style={styles.bold}>Ingreso:</Text> {item.TmCtvIng? item.TmCtvIng:null}</Text>
            <Text><Text style={styles.bold}>Cama:</Text> {item.TFcCodCam? item.TFcCodCam.trim():null}</Text>
            <Text><Text style={styles.bold}>Fecha Final:</Text>  {item.ProFecF? item.ProFecF:null}</Text> 
            <Text><Text style={styles.bold}>Pabellon:</Text>  {item.TFcNomPab?item.TFcNomPab.trim():null} </Text>
            <Text><Text style={styles.bold}>Tiem. Qx H:</Text>  {item.ProDurHr? item.ProDurHr:null}   <Text style={styles.bold}>M:</Text> {item.ProDurMn? item.ProDurMn:null} </Text>
          </View> 
          
        </View>
                <Text style={styles.date}><Text style={styles.bold}>Empresa:</Text> {item.ProNEPS? item.ProNEPS:null}</Text>
                <View>
                  <Text style={styles.date}><Text style={styles.bold}>PROCEDIMIENTO QX</Text></Text>

                  <View  style={styles.table}>
                  <View style={styles.tableRow}>
                    <View style={styles.tableCell}>
                        <Text  style={styles.bold}>CÓDIGO</Text> 
                    </View>
                    <View style={styles.tableCellLarge}> 
                        <Text  style={styles.bold}>NOMBRE DE LA CIRUGÍA</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>MEDICO </Text> 
                  </View> 
                  
                </View>
                  {
                    item.Procedimientos.map((itemProcedimiento,index)=>(
                      // <Text style={styles.date} key={index}>  </Text>
                      <View style={styles.tableRow} key={index} >
                            <View style={styles.tableCell}> 
                                <Text >{itemProcedimiento.CrgCod? itemProcedimiento.CrgCod.trim():null}</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >{itemProcedimiento.CrgDes?itemProcedimiento.CrgDes.trim():null}</Text>                                 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{item.MedNom? item.MedNom.trim():null}</Text> 
                            </View> 
                                                  
                        </View>
                    ))
                  }

                    </View>
                  
                  {/* <Text style={styles.date}>OBSERVACIONES</Text> */}
                </View>
                </>
            ))
          }
          
        </Page>
      </Document>
   
    );
}

export default PDFProgramacionCirugias